import { GrowthRateBasisType } from '@xplan-pension-switching/common';
import { useMemo } from 'react';

export const useGrowthRateTableValues = (
    selectedGrowthRateBasisType: GrowthRateBasisType,
    defaultGrowthRateBasisType: GrowthRateBasisType,
    growthRateLow?: number,
    growthRateMid?: number,
    growthRateHigh?: number
): { currentLow?: number; currentMid?: number; currentHigh?: number } => {
    const currentLow = useMemo(() => {
        if (selectedGrowthRateBasisType === GrowthRateBasisType.IndustryStandard) return undefined;
        return selectedGrowthRateBasisType === defaultGrowthRateBasisType && growthRateLow ? growthRateLow : 0;
    }, [defaultGrowthRateBasisType, growthRateLow, selectedGrowthRateBasisType]);
    const currentMid = useMemo(() => {
        if (selectedGrowthRateBasisType === GrowthRateBasisType.IndustryStandard) return undefined;
        return selectedGrowthRateBasisType === defaultGrowthRateBasisType && growthRateMid ? growthRateMid : 0;
    }, [defaultGrowthRateBasisType, growthRateMid, selectedGrowthRateBasisType]);
    const currentHigh = useMemo(() => {
        if (selectedGrowthRateBasisType === GrowthRateBasisType.IndustryStandard) return undefined;
        return selectedGrowthRateBasisType === defaultGrowthRateBasisType && growthRateHigh ? growthRateHigh : 0;
    }, [defaultGrowthRateBasisType, growthRateHigh, selectedGrowthRateBasisType]);

    return { currentMid, currentLow, currentHigh };
};
